function clampSentiment(value: number) {
  if (!Number.isFinite(value)) {
    return 0;
  }

  return Math.min(Math.max(value, 0), 1);
}

export function sentimentToColor(value: number): string {
  const sentiment = clampSentiment(value);

  if (sentiment <= 0) {
    return 'transparent';
  }

  if (sentiment <= 0.33) {
    const alpha = sentiment / 0.33;
    return `rgba(255, 220, 50, ${alpha * 0.5})`;
  }

  if (sentiment <= 0.66) {
    const t = (sentiment - 0.33) / 0.33;
    const r = 255;
    const g = Math.round(220 - t * 100);
    const b = Math.round(50 - t * 30);
    return `rgba(${r}, ${g}, ${b}, 0.55)`;
  }

  const t = (sentiment - 0.66) / 0.34;
  const r = 255;
  const g = Math.round(120 - t * 80);
  const b = Math.round(20 - t * 20);
  return `rgba(${r}, ${g}, ${b}, ${0.55 + t * 0.2})`;
}
